// extracted by mini-css-extract-plugin
export default {"result":"Results_result__Dnf66"};